import { orderSliceActions } from 'app/pages/order/redux/order-slice';
import type { AppDispatch, AppState } from 'app/redux/types/types';
import { HouseType } from 'app/pages/order/model/house-type';
import { selectPartner, selectShoppingCartOrThrow } from 'app/pages/order/redux/order-selector';
import { pushSelectItemToCartEvent } from 'app/data-layers/events/push-select-item-to-cart-event';

import { changeIsPurchasingSingleUnitActionCreator } from './change-is-purchasing-single-unit-action-creator';

export const selectHouseTypeActionCreator =
    (houseType: HouseType) => (dispatch: AppDispatch, getState: () => AppState) => {
        const rootState = getState();
        const shoppingCart = selectShoppingCartOrThrow(rootState);
        const partner = selectPartner(rootState);

        dispatch(orderSliceActions.selectHouseType(houseType));
        dispatch(changeIsPurchasingSingleUnitActionCreator(false));
        pushSelectItemToCartEvent(shoppingCart, houseType, partner);
    };
